import React from 'react';
import { MapPin, Shield, CheckCircle, Calendar, Award, Heart } from 'lucide-react';
import { whyChooseUsData } from '../mock';

const iconMap = {
  MapPin: MapPin,
  Shield: Shield,
  CheckCircle: CheckCircle,
  Calendar: Calendar,
  Award: Award,
  Heart: Heart
};

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="py-24 bg-white relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://images.pexels.com/photos/6195121/pexels-photo-6195121.jpeg"
          alt="Professional Team"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Why Choose Us
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Experience the difference with our dedicated cleaning services
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUsData.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-slate-50 hover:bg-teal-50 border-2 border-transparent hover:border-teal-600 transition-all duration-300"
              >
                <div className="mb-4">
                  <div className="inline-flex p-3 bg-teal-600 group-hover:bg-teal-700 rounded-xl transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-white" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
